import { useContext, useState, useEffect } from 'react';

import Cookies from 'js-cookie';

import BottomAdContext from '@lcsc-ui/context/BottomAdContext';
import useUserStore from '@lcsc-ui/store/user';
let tmId;
const IndexBottomFloatAd = ({ headerAd }) => {
  const [bottomFloatAdShow, setBottomFloatAdShow] = useState(false);
  const { setAnimateShow } = useContext(BottomAdContext);
  const { userInfo } = useUserStore();

  useEffect(() => {
    const fixedBottomAdTime = Cookies.get('fixedBottomAdTime');
    if (!fixedBottomAdTime || fixedBottomAdTime !== new Date().getDate()) {
      if (headerAd?.bottomFloatAd && userInfo?.customerLogin === 0) {
        setBottomFloatAdShow(true);
        tmId = setTimeout(() => {
          closeBottomFloatAd();
        }, 10000);
      } else {
        setBottomFloatAdShow(false);
      }
    }
    return () => {
      clearTimeout(tmId);
    };
  }, [headerAd, userInfo]);

  function closeBottomFloatAd(e) {
    e && e.stopPropagation();
    Cookies.set('fixedBottomAdTime', new Date().getDate(), {
      domain: '.szlcsc.com',
      path: '/',
    });
    setBottomFloatAdShow(false);
    setAnimateShow(true);
    clearTimeout(tmId);
  }

  return (
    <>
      {/* 底部悬浮广告 */}
      {bottomFloatAdShow && (
        <section className="fixed bottom-0 left-0 z-10 w-full">
          <button
            className="absolute right-[10px] top-[10px] z-[2] size-[18px] bg-[url(https://static.szlcsc.com/ecp/assets/web/layout/head/images/close_top.png)] p-[4px] hover:opacity-50"
            onClick={closeBottomFloatAd}
          ></button>
          <a
            className="w-full"
            target="_blank"
            href={headerAd.bottomFloatAd?.targetLink}
            title={headerAd.bottomFloatAd.title}
          >
            <section
              className="mx-auto h-[120px] max-w-[3840px]"
              style={{
                background: `url(${headerAd.bottomFloatAd.advertisingUrl}) center center no-repeat`,
                backgroundSize: 'auto 100%',
              }}
            ></section>
          </a>
        </section>
      )}
    </>
  );
};
export default IndexBottomFloatAd;
